<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div v-show="CheckRoute()" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet kt-portlet--mobile">
          <div class="kt-portlet__head kt-portlet__head--lg">
            <div class="kt-portlet__head-label">
              <span class="kt-portlet__head-icon">
                <i class="fa fa-money-check-alt"></i>
              </span>
              <h3 class="kt-portlet__head-title">
                {{ this.$route.meta.breadcrumb }}
              </h3>
            </div>
          </div>
          <div class="kt-portlet__body">
            <!-- begin: Search Form -->
            <form class="kt-form" @submit="formSubmit" ref="searchForm">
              <div class="row">
                <!-- Begin:ชื่องบประมาณ select2 -->
                <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                  <div class="form-group">
                    <label>คำค้นหา :</label>
                    <input
                      v-model="blKeyword"
                      type="text"
                      class="form-control"
                      placeholder="ค้นหาจากชื่องบประมาณ โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่องบประมาณ1, ชื่องบประมาณ2"
                    />
                  </div>
                </div>
                <!-- End:แบรนด์สินค้า select2 -->
                <!-- Begin:ประเภทงบประมาณ select2 -->
                <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                  <div class="form-group">
                    <label>ประเภทงบประมาณ :</label>
                    <!-- <select2
                      :class="'form-control m-select2'"
                      :style="'width: 100%;'"
                      :id="'blBudgetType'"
                      :name="'blBudgetType'"
                      :multiple="true"
                      :select2-options="blBudgetTypeOptions"
                      v-model="blBudgetType"
                      ref="BlBudgetTypeSelect2"
                    ></select2> -->
                    <treeselect
                      v-model="blBudgetType"
                      :multiple="true"
                      :options="blBudgetTypeOptions"
                      :clear-on-select="true"
                      placeholder="กรุณาเลือก"
                    />
                  </div>
                </div>
                <!-- End:ประเภทงบประมาณ select2 -->

                <!-- Begin:ปี(งบประมาณ) input -->
                <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                  <div class="form-group">
                    <label>ปี(งบประมาณ) :</label>
                    <select2
                      :class="'form-control m-select2'"
                      :style="'width: 100%;'"
                      :id="'blYear'"
                      :name="'blYear'"
                      :select2-options="blYearOptions"
                      v-model="blYear"
                      ref="BlYearSelect2"
                    ></select2>
                  </div>
                </div>
                <!-- End:ปี(งบประมาณ) input -->
                <!-- Begin:Status select2 -->
                <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                  <div class="form-group">
                    <label>สถานะ:</label>
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'blStatus'"
                      :name="'blStatus'"
                      :select2-options="blStatusOptions"
                      v-model="blStatus"
                      ref="BlStatusSelect2"
                    ></select2>
                  </div>
                </div>
                <!-- End:Status select2 -->
              </div>
              <div class="row mb-3">
                <div class="col-xl-6">
                  <button type="submit" class="btn btn-primary">ค้นหา</button>
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    @click="formReset"
                  >
                    ล้างค่าทั้งหมด
                  </button>
                </div>
                <div class="col-xl-6 text-right">
                  <router-link
                    to="ManageBrand/Add"
                    tag="button"
                    title="เพิ่ม"
                    class="btn btn-outline-brand"
                    v-if="this.$root.canShow(['MANAGE_MASTER', 'MANAGE_BRAND'])"
                  >
                    <i class="fa fa-plus-circle"></i> เพิ่มข้อมูลงบประมาณแบรนด์
                  </router-link>
                  <router-link
                    to="ManageBrand/Export"
                    tag="button"
                    title="Export"
                    class="btn btn-outline-brand"
                    v-if="this.$root.canShow(['MANAGE_MASTER', 'MANAGE_BRAND'])"
                  >
                    <i class="fa fa-file-export"></i> Export
                  </router-link>
                </div>
              </div>
            </form>
            <!-- end: Search Form -->

            <!--begin: Datatable -->
            <div class="row">
              <div class="col-lg-12 table-responsive">
                <table
                  class="table-sm table-striped- table-bordered table-hover table-checkable"
                  id="brandTable"
                >
                  <thead>
                    <tr>
                      <th class="all">ชื่องบประมาณ</th>
                      <th class="all">ประเภทงบประมาณ</th>
                      <th class="all">ปี(งบประมาณ)</th>
                      <th class="all">งบประมาณ</th>
                      <th class="all">ใช้ไป</th>
                      <th class="all">คงเหลือ</th>
                      <th class="all">สถานะ</th>
                      <th class="all">การจัดการ</th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
            <!--end: Datatable -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");
let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#brandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/BudgetBrand/" + this.data.budgetId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#brandTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/BudgetBrand/" + this.data.budgetId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let BudgetBrandActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูลงบประมาณรายแบรนด์">
      <i class="la la-edit"></i>
    </a>
    <a href="#" @click.prevent="deleteBudget" v-if="data.showDeleteButton" title="ลบข้อมูลงบประมาณรายแบรนด์" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    edit: function() {
      router.push({
        path: `/Master/ManageBrand/Edit/${this.data.budgetId}`,
      });
    },
    deleteBudget: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบข้อมูลงบประมาณ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูลงบประมาณรายแบรนด์ <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ข้อมูลงบประมาณรายแบรนด์นี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลงบประมาณรายแบรนด์ออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });
          axios
            .put("/Api/BudgetBrand/" + this.data.budgetId + "/Delete")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      DatePickerFormat: "yyyy",
      blKeyword: null,
      blBudgetType: [],
      blBudgetTypeOptions: [],
      blYear: null,
      blStatus: null,
      blProductBrandIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2ProductBrand",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },

      // blBudgetTypeOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options",
      //     data: function(params) {
      //       var query = {
      //         search: "BUDGET_TYPE",
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },

      blYearOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/BudgetBrand/Select2BudgetYear",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },

      blStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
    };
  },
  methods: {
    formReset: function(e) {
      this.blKeyword = null;

      this.blBudgetType = [];

      $("#blYear")
        .val("")
        .trigger("change");

      //default Active Data
      this.blStatus = false;
      $("#blStatus")
        .val(this.blStatus + "")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#brandTable").DataTable();
      table.search(this.equipment);
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#brandTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    CheckRoute() {
      var url = this.$route.path;
      console.log(this.$route.params.id);
      if (url == "/Master/ManageBrand/Edit/" + this.$root.$route.params.id)
        return false;
      else if (url == "/Master/ManageBrand/Add") return false;
      else return true;
    },
    LoadblBudgetTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options", {
          params: {
            page: 1,
            search: "BUDGET_TYPE",
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.blBudgetTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;

    //default Active Data
    self.blStatus = false;
    $("#blStatus")
      .val(self.blStatus + "")
      .trigger("change");

    $("#brandKey").select2({
      tags: true,
      placeholder: "กรุณาเลือก",
      allowClear: true,
    });

    self.LoadblBudgetTypeOptions();

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#brandTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/BudgetBrand/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                BudgetName: self.blKeyword,
                BudgetType: self.blBudgetType,
                Year: self.blYear,
                ActiveStatus: self.blStatus,
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[1, "desc"]],
        columns: [
          { data: "budgetName" },
          { data: "budgetTypeDesc", width: "20%" },
          { data: "year" },
          {
            data: "budget",
            render: function(value) {
              return self.$options.filters.currency(value, "฿");
            },
          },
          {
            data: "usedAmout",
            render: function(value) {
              return self.$options.filters.currency(value, "฿");
            },
          },
          {
            data: "balance",
            render: function(value) {
              return self.$options.filters.currency(value, "฿");
            },
          },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "budgetId",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_BRAND",
            ]);
            if (data.inActiveStatus == false)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == true)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_BRAND",
            ]);
            data.showDeleteButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_BRAND",
            ]);
            new BudgetBrandActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    table.trigger("draw.dt"); //call ajax delete this row
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Brand/BrandList.vue